/**
 *
 * LOGIN
 *
 */

import { mapGetters, mapActions, mapState } from 'vuex';
import Swal from 'sweetalert2';
import $ from 'jquery';

import Spinner from '@/components/Spinner.vue';
import { MobileMixin } from '@/mixins/Mobile';
import { SettingMixin } from '@/mixins/Setting';
import { DASHBOARD_PAGE } from '@/constants/routes';
import { LOADING_MESSAGE } from './Login.constants';
import { cookieGetItem, cookieSetItem } from '@/global/cookie';
import { postFingerPrint } from '@/global/fingerPrint';
import { getIsMobile } from '@/utils/browser';

export const LoginCommonMixin = {
  name: 'LoginCommonMixin',

  mixins: [MobileMixin],

  data: () => {
    return {
      isInvalid: false,
      countParamsInUrl: 0,
      //
      vendorId: null,
      captcha: null,
    };
  },

  watch: {
    region() {
      this.clearError();
    },

    shortMobile() {
      this.clearError();
    },

    mobileCode() {
      this.clearError();
    },
  },

  methods: {
    ...mapActions({
      ma_getUserInfo: 'getUserInfo',
    }),

    clearError() {
      this.isInvalid = false;
    },

    async getUserInfo() {
      const promisePostFingerPrint = postFingerPrint();
      await this.ma_getUserInfo();
      await promisePostFingerPrint;
    },

    _makeUrlAddParams() {
      let paramsUrl = '';
      this.countParamsInUrl = 0;
      if (Object.keys(this.$route.query).length) {
        for (let k in this.$route.query) {
          if ('code' !== k && 'state' !== k) {
            paramsUrl += this.countParamsInUrl ? '&' : '?';
            paramsUrl += k + '=' + encodeURIComponent(this.$route.query[k]);
            this.countParamsInUrl++;
          }
        }
      }
      return paramsUrl;
    },

    _makeUrlAddHash() {
      return this.$route.hash;
    },

    _makeUrlAddParamsAndHash() {
      return this._makeUrlAddParams() + this._makeUrlAddHash();
    },
  },

  created() {
    this.vendorId = cookieGetItem('vendorId') ? parseInt(cookieGetItem('vendorId')) : undefined;
    this.getRegionNo();
  },
};

export const LoginMixin = {
  name: 'LoginMixin',

  mixins: [LoginCommonMixin, SettingMixin],

  components: {
    Spinner,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
      step: '',
      loginType: 'passwd',
      username: '',
      isUsernameMobileExist: '',
      password: '',
      isAgreed: false,

    };
  },

  computed: {
    ...mapGetters({
      loginStatus: 'Login/loginStatus',
      loginMessage: 'Login/loginMessage',
      loginData: 'Login/loginData',
      mg_userInfo: 'userInfo',
      loading: 'loading',
      immLoading: 'immLoading',
    }),

    ...mapState({
      ms_isWechatBrowser: (state) => state.browserInfo.isWechatBrowser,
    }),

    ...mapState('Login', {
      ms_qrcodeStatus: 'qrcodeStatus',
      wechatBinding: 'wechatBinding',
      wechatUser: 'wechatUser',
    }),

    c_isShowSpinner() {
      return this.$route.query.code;
    },

    c_isNicknameReady() {
      return this._c_isNicknameReady || this.nickname === this.wechatUser.nickname;
    },

    c_isPostLoginSmsRegisterNewUserDisabled() {
      return !this.c_isNicknameReady || !this.newPassword || this.newPassword.length < 8;
    },
  },

  methods: {
    ...mapActions({
      ma_getTutorInfo: 'getTutorInfo',
    }),

    ...mapActions('Mixins/Mobile', {
      ma_checkExistMobile: 'checkExistMobile',
    }),

    ...mapActions('Login', {
      wxLogin: 'wxLogin',
      getIMToken: 'getIMToken',
      ma_postLoginSms: 'postLoginSms',
      ma_postSmsRegisterMobilePrecheck: 'postSmsRegisterMobilePrecheck',
      ma_postSmsRegisterWechatPrecheck: 'postSmsRegisterWechatPrecheck',
      ma_postLoginSmsRegisterNewUser: 'postLoginSmsRegisterNewUser',
      ma_checkLoginQrcode: 'checkLoginQrcode',
      ma_checkCaptcha: 'checkCaptcha'
    }),

    warnIfNoFingerPrint() {
      if (undefined === window.Fingerprint2) {
        Swal.fire({
          width: '400px',
          icon: 'warning',
          title: '请关闭浏览器防广告插件，否则无法登录！',
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        });
        return true;
      }
    },

    clearError() {
      this.isInvalid = false;
      this.isUsernameMobileExist = '';
    },

    setLoginType(loginType) {
      this.loginType = loginType;
    },

    handleChangeUsername() {
      this.clearError();
      /* if (RE_ALL_NUMBER.test(this.username)) {
        const res = await this.ma_checkExistMobile('+86' + this.username);
        this.isUsernameMobileExist = res.data.data;
      } */
    },

    async doLoginPasswd() {
      if (this.warnIfNoFingerPrint()) {
        return false;
      }
      if (!this.password || !this.username) {
        this.isInvalid = true;
        return;
      }
      await this.$store.dispatch('Login/postLogin', {
        j_username: this.username.toLowerCase(),
        j_password: this.password,
        vendorId: this.vendorId,
      });
      this.isUsernameMobileExist = '';
      if (this.loginStatus === 200) {
        await this.getUserInfo();
        cookieSetItem('isLoginFromWechat', 'false');
        this._afterLogin();
      } else {
        this.isInvalid = true;
      }
    },

    async doLoginMobile() {
      if (this.warnIfNoFingerPrint()) {
        return false;
      }
      if (!this.mobileCode || !this.shortMobile) {
        this.isInvalid = true;
        return;
      }
      await this.ma_postLoginSms({
        smsCode: this.mobileCode,
        mobile: this.c_mobile,
        shortMobile: this.shortMobile,
        //bindWechat: 'true' === cookieGetItem('isLoginFromWechat'),
        //password: '345677',
        vendorId: this.vendorId,
        //device: 1,
      });
      if (this.loginStatus === 200) {
        await this.getUserInfo();
        cookieSetItem('isLoginFromWechat', 'false');
        this._afterLogin();
      } else {
        this.isInvalid = true;
      }
    },

    closeCaptcha() {
      $(`#loginCaptchaModal`).modal('hide');
      this.captcha.reset();
    },

    _doLogin() {
      if ('passwd' === this.loginType) {
        this.doLoginPasswd();
      } else if ('sms' === this.loginType) {
        this.doLoginMobile();
      }
    },

    doLogin() {
      if (!getIsMobile()) {
        const _this = this;
        $(`#loginCaptchaModal`).modal('show');
        if (!this.captcha) {
          this.captcha = sliderCaptcha({
            id: 'captcha',
            width: 280,
            height: 150,
            sliderL: 42,
            sliderR: 9,
            offset: 5,
            loadingText: '正在加载中...',
            failedText: '再试一次',
            barText: '向右滑动填充拼图',
            repeatIcon: 'fa fa-redo',
            remoteUrl: '/api/nuxt/public/slidercaptcha',
            setSrc: function () {
              return 'https://resources.pzacademy.com/img/captcha/captcha' + parseInt(Math.random() * 20 + 0) + '.jpg';
            },
            verify: async (arr) => {
              // console.log(arr)
              const ret = await _this.ma_checkCaptcha({ numbers: arr });
              // console.log(ret)
              return ret.data.data;
            },
            onSuccess: () => {
              _this._doLogin();
              _this.closeCaptcha()
            }
          });
        }
        // if ('passwd' === _this.loginType) {
        //   _this.doLoginPasswd();
        // } else if ('sms' === _this.loginType) {
        //   _this.doLoginMobile();
        // }
        return
      } else {
        this._doLogin();
      }
    },

    async postSmsRegisterMobilePrecheck() {
      if (!this.isAgreed) {
        return;
      }

      if (this.warnIfNoFingerPrint()) {
        return false;
      }
      if (!this.c_isMobileReady || !this.c_isMobileCodeReady) {
        return;
      }
      await this.ma_postSmsRegisterMobilePrecheck({
        smsCode: this.mobileCode,
        mobile: this.c_mobile,
        shortMobile: this.shortMobile,
        vendorId: this.vendorId,
      });
      if (this.loginStatus === 200) {
        this.setStepIsRegisterMobile();
      } else {
        this.isInvalid = true;
      }
    },

    async postSmsRegisterWechatPrecheck() {
      if (this.warnIfNoFingerPrint()) {
        return false;
      }
      if (!this.c_isMobileReady || !this.c_isMobileCodeReady) {
        return;
      }
      await this.ma_postSmsRegisterWechatPrecheck({
        unionId: this.wechatUser.unionid,
        smsCode: this.mobileCode,
        mobile: this.c_mobile,
        shortMobile: this.shortMobile,
        vendorId: this.vendorId,
      });
      if (this.loginStatus === 200) {
        if (1 == this.loginData) {
          this.setStepIsRegisterMobile();
        } else if (2 == this.loginData) {
          await this.getUserInfo();
          cookieSetItem('isLoginFromWechat', 'false');
          this._afterLogin();
        } else if (3 == this.loginData) {
          this.isInvalid = true;
        }
      } else {
        this.isInvalid = true;
      }
    },

    async postLoginSmsRegisterNewUser() {
      if (this.warnIfNoFingerPrint()) {
        return false;
      }
      if (!this.c_isNicknameReady || !this.c_isNewPasswordReady) {
        return;
      }
      await this.ma_postLoginSmsRegisterNewUser({
        //email: this.username.toLowerCase(),
        unionId: this.wechatUser.unionid ? this.wechatUser.unionid : undefined,
        mobile: this.c_mobile,
        shortMobile: this.shortMobile,
        nickName: this.nickname,
        password: this.newPassword,
        vendorId: this.vendorId,
      });
      if (this.loginStatus === 200) {
        await this.getUserInfo();
        cookieSetItem('isLoginFromWechat', 'false');
        this._afterLogin();
      } else {
        this.isInvalid = true;
      }
    },

    setStepBlank() {
      this.step = '';
      this.clearError();
    },

    setStepIsRegisterMobile() {
      this.nickname = this.wechatUser.nickname ? this.wechatUser.nickname : '';
      this.newPassword = '';
      this.step = 'isRegisterMobile';
    },

    //
    async checkWechatQrcode() {
      if (this.isQrCodeHandled) {
        return;
      }
      await this.ma_checkLoginQrcode({
        wechatCode: this.ms_wechatQrcodeInfo.wechatCode,
        vendorId: this.vendorId,
      });
      if (this.isQrCodeHandled) {
        return;
      }
      //1  -1  -2  -3  分别代表 扫码成功  扫码失败  未扫码  二维码超时失效
      if (-2 === this.ms_qrcodeStatus) {
        return;
      }
      this.isQrCodeHandled = true;
      clearInterval(this.itvlcheckWechatQrcode);
      if (-3 === this.ms_qrcodeStatus) {
        this.isQrCodeHandled = 'timeout';
        return;
      }
      if (-1 === this.ms_qrcodeStatus) {
        this.isInvalid = true;
        this.afterWxLoginError();
        return;
      }
      if (1 === this.ms_qrcodeStatus) {
        cookieSetItem('isLoginFromWechat', 'true');
        this.afterWxLogin();
        if (this.wechatBinding) {
          await this.getUserInfo();
          this._afterLogin();
          return;
        } else {
          this.step = 'wechatBinding';
        }
      }
    },

    handleWechatLoginClick() {
      this.checkWechatQrcodeAndSetItvl();
    },

    closeWxcodeModal() {
      clearInterval(this.itvlcheckWechatQrcode);
      this.clearError();
    },

    //
    afterLogin() { },

    _afterLogin() {
      this.afterLogin();
      this.setStepBlank();
      this.getIMToken();
      this.ma_getTutorInfo();
    },

    afterWxLogin() { },

    afterWxLoginError() { },

    _loginCreated() { },

    async _loginMounted() {
      await this.getWechatQrcode();
      //if (this.ms_isWechatBrowser) {
      //  this.$refs.btnWechatLogin.click();
      //}
    },
  },
};

export const AfterLoginMixin = {
  name: 'AfterLoginMixin',

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),
  },

  methods: {
    ...mapActions({
      ma_afterLoginComplete: 'afterLoginComplete',
    }),

    goToNextPage() {
      window.localStorage.setItem('isLoginNotDashboard', 'true');
      if (this.$route.query.redirect_uri) {
        let redirect_uri = decodeURIComponent(this.$route.query.redirect_uri);
        if (this.$route.query.isFromEvent) {
          redirect_uri += '&studentId=' + this.mg_userInfo.studentId;
        }
        redirect_uri += this.$route.hash;
        window.location.href = redirect_uri;
      } else if (this.$route.query.login_redirect_uri) {
        this.$router.push(decodeURIComponent(this.$route.query.login_redirect_uri));
        this.ma_afterLoginComplete();
      } else {
        this.$router.push(DASHBOARD_PAGE);
        this.ma_afterLoginComplete();
      }
    },
  },
};
